import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

let bugsnagClient;
if (process.env.VUE_APP_BUGSNAG && process.env.NODE_ENV !== 'test') {
  let environment = process.env.NODE_ENV || 'development';
  if (environment === 'prod') {
    environment = 'production';
  } else if (environment === 'dev') {
    environment = 'production-dev';
  } else if (environment === 'stage') {
    environment = 'staging';
  }
  bugsnagClient = Bugsnag.createClient({
    apiKey: process.env.VUE_APP_BUGSNAG,
    releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE || environment,
    appVersion: process.env.VUE_APP_BUGSNAG_APP_VERSION,
    appType: process.env.VUE_APP_BUGSNAG_APP_TYPE,
    plugins: [new BugsnagPluginVue(Vue)],
  });
}

export default bugsnagClient;
